import axios from 'axios';
import { API_HOST } from '../consts';

export const fetchRespostasCPA = async (params) => {
  const res = await axios.get(`${API_HOST}/academico/answer_quiz`, {
    params,
  });
  return res.data;
};
